export default __webpack_public_path__ + "static/media/postify-site.e46cb1e7.png";